<template>
  <div>
    <div class="div_hint">
      <label class="label_title">{{ textLabel }}</label>
      <button
        v-show="showBtn"
        @click="showHint = !showHint"
        class="btn_hint"><font-awesome-icon
        :icon="showHint ? 'times' : 'question'"
      /></button>
    </div>
    <transition
      name="fade"
    >
      <div
        class="hint_text"
        v-if="showHint"
      >
        <span>{{ textHint }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LabelHintComp',
  props: {
    textLabel: { type: String, default: () => '' },
    textHint: { type: String, default: () => '' },
    showBtn: { type: Boolean, default: () => false }
  },
  data: function () {
    return {
      showHint: false
    }
  }
}
</script>

<style scoped lang="scss">

.div_hint {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto;
  grid-gap: 5px;
  margin-bottom: 10px;
}
.div_hint > label {
  margin: 0 auto 0 0!important;
}
.div_hint > button {
  margin: auto!important;
}

.btn_hint {
  color: #bababa;
  border: 1px solid #bababa;
  border-radius: 5px;
}
.btn_hint:hover {
  color: #ff8200;
}

.hint_text {
  text-align: justify;
  margin: 5px;
  font-size: 14px;
  background-color: #DCDCDC;
  border-radius: 5px;
  padding: 5px;
}

.fade-enter-active {
  animation: bounce-in .8s;
}
.fade-leave-active {
  animation: bounce-in .1s reverse;
  transition: all .0s ease;
}
@keyframes fade-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

</style>
